import { render, staticRenderFns } from "./studentRecordStatistics.vue?vue&type=template&id=65e14dce&scoped=true"
import script from "./studentRecordStatistics.vue?vue&type=script&lang=js"
export * from "./studentRecordStatistics.vue?vue&type=script&lang=js"
import style0 from "./studentRecordStatistics.vue?vue&type=style&index=0&id=65e14dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e14dce",
  null
  
)

export default component.exports